import React, {Component} from 'react';

class StoryArticle extends Component{
	constructor(props){
		super(props);
		this.state = {
			index: this.props.index,
			photo1: this.props.photo1,
			photo2: this.props.photo2,
			photo3: this.props.photo3,
			photo4: this.props.photo4,
			photo5: this.props.photo5,
			photo6: this.props.photo6,
			photo7: this.props.photo7,
			para1: this.props.para1,
			para2: this.props.para2,
			para3: this.props.para3,
			para4: this.props.para4,
			para5: this.props.para5,
			para6: this.props.para6,
			para7: this.props.para7,
			para8: this.props.para8,
			para9: this.props.para9
		};
	}
	
	render(){
		return (
			<div>

				{this.state.para1 !== "" ?
					<div>
						{this.state.para1.map((paragraph, i) => (
							<div className="para-content" key={i}>{paragraph}</div>
							)
						)}
					</div>
				: ""}

				{this.state.photo1 !== undefined ?
					<div className="story-photo-wrapper">
						<img alt="" src={this.state.photo1} className=""/>
					</div>
				: ""}

				{this.state.para2 !== "" ?
					<div>
						{this.state.para2.map((paragraph, i) => (
							<div className="para-content" key={i}>{paragraph}</div>
							)
						)}
					</div>
				: ""}

				{this.state.photo2 !== undefined ?
					<div className="story-photo-wrapper">
						<img alt="" src={this.state.photo2} className=""/>
					</div>
				: ""}

				{this.state.para3 !== "" ?
					<div>
						{this.state.para3.map((paragraph, i) => (
							<div className ="para-content" key={i}>{paragraph}</div>
							)
						)}
					</div>
				: ""}	

				{this.state.photo3 !== undefined ?
					<div className="story-photo-wrapper">
						<img alt="" src={this.state.photo3} className=""/>
					</div>
				: ""}		

				{this.state.para4 !== "" ?
					<div>
						<div className="para-content">
							{this.state.para4.map((paragraph, i) => (
								<div key={i}>{paragraph}</div>
								)
							)}
						</div>
					</div>
				: ""}	

				{this.state.para5 !== "" ?
					<div>
						{this.state.para5.map((paragraph, i) => (
							<div className ="para-content" key={i}>{paragraph}</div>
							)
						)}
					</div>
				: ""}	

				{this.state.photo4 !== undefined ?
					<div className="story-photo-wrapper">
						<img alt="" src={this.state.photo4} className=""/>
					</div>
				: ""}

				{this.state.para6 !== "" ?
					<div>
						{this.state.para6.map((paragraph, i) => (
							<div className ="para-content" key={i}>{paragraph}</div>
							)
						)}
					</div>
				: ""}

				{this.state.photo5 !== undefined ?
					<div className="story-photo-wrapper">
						<img alt="" src={this.state.photo5} className=""/>
					</div>
				: ""}

				{this.state.para7 !== "" ?
					<div>
						{this.state.para7.map((paragraph, i) => (
							<div className ="para-content" key={i}>{paragraph}</div>
							)
						)}
					</div>
				: ""}

				{this.state.photo6 !== undefined ?
					<div className="story-photo-wrapper">
						<img alt="" src={this.state.photo6} className=""/>
					</div>
				: ""}

				{this.state.para8 !== "" ?
					<div>
						{this.state.para8.map((paragraph, i) => (
							<div className ="para-content" key={i}>{paragraph}</div>
							)
						)}
					</div>
				: ""}

				{this.state.photo7 !== undefined ?
					<div className="story-photo-wrapper-7">
						<img alt="" src={this.state.photo7} className=""/>
					</div>
				: ""}

				{this.state.para8 !== ""  ?
					<div className="g">
						{this.state.para9.map((paragraph, i) => (
							<div className ="para-content" key={i}>{paragraph}</div>
							)
						)}
					</div>
				: ""}


			</div>
		);
	}
}

export default StoryArticle;